// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const guestList_enterGuestName = (i) => `Bitte gib einen Namen für den Gast an.`